import { DCL_EXTRANET, DCL_INTRANET } from '@/def/domain';
import { isIntranet, isTestEnv } from '@/util/dev-tool';

// 先区分内外网,再区分测试环境和正式环境
const getBaseUrl = () => {
  const baseUrl = { dcl: '', gateWay: '' };
  if (window.origin !== 'null' && !window.origin.includes('localhost')) {
    baseUrl.dcl = window.origin;
    return baseUrl;
  }
  // 内网网络
  if (isIntranet()) {
    // 测试环境
    if (isTestEnv()) {
      baseUrl.dcl = DCL_INTRANET.development;
    } else {
      baseUrl.dcl = DCL_INTRANET.productionHttps;
    }
    // 外网网络
  } else {
    // 测试环境
    if (isTestEnv()) {
      baseUrl.dcl = DCL_EXTRANET.development;
    } else {
      baseUrl.dcl = DCL_EXTRANET.production;
    }
  }
  return baseUrl;
};

const baseUrl = getBaseUrl();

export default baseUrl;
